<template>
  <div class="security-wrapper">
    <div class="content">
      <div class="record-title">
        <div class="title-con">
          <div class="icon"></div>
          <div class="title">组件调用分析</div>
        </div>
      </div>
      <div id="chartfenxi"></div>
      <div class="record-title">
        <div class="title-con">
          <div class="icon"></div>
          <div class="title">数据上/下行统计</div>
        </div>
      </div>
      <div id="chartsx"></div>
      <div class="record-title">
        <div class="title-con">
          <div class="icon"></div>
          <div class="title">组件调用记录</div>
        </div>
        <!-- <div class="more">更多</div> -->
      </div>
      <dv-scroll-board
        :config="recordConfig2"
        style="width: 100%; height: 300px"
      />
    </div>
  </div>
</template>

<script>
// import Title from "@/components/Commen/CloseTitle";
const echarts = require("echarts");
import { chartone, charttwo } from "./charts";
import { mapState } from "vuex";
import pollingFunction from "@/utils/tools";

export default {
  components: {},
  data() {
    return {
      recordConfig2: {},
      pollingST: null,
    };
  },
  computed: {
    ...mapState(["componentCallsData"]),
  },
  async mounted() {
    if (!this.pollingST) {
      setTimeout(() => {
        this.pollingST = pollingFunction(this.drawChart, 3000);
      }, 3000);
    }
    await this.drawChart();
  },
  beforeDestroy() {},
  methods: {
    drawChart() {
      let fenxichart = echarts.init(document.getElementById("chartfenxi"));
      let sxchart = echarts.init(document.getElementById("chartsx"));
      fenxichart.setOption(
        chartone(this.componentCallsData.data.data.moduleInvoking)
      );
      sxchart.setOption(
        charttwo(
          this.componentCallsData.data.data.upNum,
          this.componentCallsData.data.data.downNum
        )
      );
      let data = this.componentCallsData.data.data.moduleInvokingLogBean.map(
        (el) => {
          return [this.formatterDate(el.createdDate), el.moduleTypeName];
        }
      );
      this.recordConfig2 = {
        header: ["时间", "业务类型"],
        rowNum: 6,
        columnWidth: [150],
        headerBGC: "rgba(0,0,0,0)",
        oddRowBGC: "rgba(103, 118, 137, 0.3)",
        evenRowBGC: "rgba(0,0,0,0)",
        data: data,
      };
    },

    formatterDate(item) {
      if (!item) return "";
      return item.substr(5).substr(0, 11);
    },
  },
  destroyed() {
    clearTimeout(this.pollingST);
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 10px;
  width: 450px;
  // width: calc(100% - 20px);
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #fff;
  font-size: 14px;
  border: 1px solid #00ccff;
  background-color: rgba(39, 98, 113, 0.3);

  .record-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    line-height: 30px;
    color: #fff;
    .title-con {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .icon {
      width: 24px;
      height: 24px;
      background: url("../../assets/index/title-icon.png") no-repeat center;
      background-size: contain;
      vertical-align: middle;
    }
    .title {
    }
    .more {
      color: rgb(81, 218, 239);
      font-size: 14px;
      cursor: pointer;
    }
  }
  #chartfenxi {
    width: 100%;
    height: 200px;
  }
  #chartsx {
    width: 100%;
    height: 200px;
  }
}
</style>
